const initialState = {    
    //invoices search
    izvjestaji: [],
    endDate: new Date(),
    startDate: null,
    loadingIzvjestaji: false,
    startDateIzvjestaji: null,
    endDateIzvjestaji: null
};


const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {

    case "CLIENT_MAP_IZVJESTAJI_START_DATE_IZVJESTAJI":
        return{
            ...state,
            startDateIzvjestaji: action.data        
        }

    case "CLIENT_MAP_IZVJESTAJI_END_DATE_IZVJESTAJI":
        return{
            ...state,
            endDateIzvjestaji: action.data        
        }

    case "CLIENT_MAP_LOADING_IZVJESTAJI":
        return{
            ...state,
            loadingIzvjestaji: action.data        
        }

    case "CLIENT_MAP_IZVJESTAJI_START_DATE":
        return{
            ...state,
            startDate: action.data        
        }

    case "CLIENT_MAP_IZVJESTAJI_END_DATE":
        return{
            ...state,
            endDate: action.data        
        }

    case "CLIENT_MAP_IZVJESTAJI":
        return{
            ...state,
            izvjestaji: action.data      
        }
      
    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
